export default {
    LOAD_PATIENTS: "LOAD_PATIENTS",
    SYNC_DATABASE: "SYNC_DATABASE",
    INIT_UUID: "INIT_UUID",
    LOAD_DRUGS: "LOAD_DRUGS",
    SYNC_IMAGES: "SYNC_IMAGES",
    STOP_SYNC: "STOP_SYNC",
};
